var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mr-lg-3",attrs:{"rounded":"","large":"","color":"accent"},on:{"click":_vm.selectImage}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-camera")]),_vm._v(" camera ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }